module.exports = __webpack_public_path__ + "img/ultimate.5193e825.png";